import * as i0 from '@angular/core';
import * as i1 from './window.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/cdk/bidi';
import * as i4 from '@angular/cdk/scrolling';
import * as i5 from '@angular/cdk/overlay';
import * as i6 from '@angular/cdk/portal';
import * as i7 from '../cdk/overlay/mapping';
import * as i8 from '../cdk/overlay/overlay-container';
import * as i9 from '../card/card.component';
import * as i10 from '../card/reveal-card/reveal-card.component';
import * as i11 from '../card/flip-card/flip-card.component';
import * as i12 from '../card/shared/shared.component';
import * as i13 from '../icon/icon.component';
import * as i14 from '../button/button.component';
import * as i15 from './windows-container.component';
import * as i16 from './window.component';
import * as i17 from '../cdk/overlay/overlay.module';
import * as i18 from '../card/card.module';
import * as i19 from '../icon/icon.module';
import * as i20 from '../button/button.module';
export const ElWindowModuleNgFactory:i0.NgModuleFactory<i1.ElWindowModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.Dir = (<any>(null as any));
var _decl0_12:i4.CdkFixedSizeVirtualScroll = (<any>(null as any));
var _decl0_13:i4.CdkScrollable = (<any>(null as any));
var _decl0_14:i4.CdkVirtualForOf<any> = (<any>(null as any));
var _decl0_15:i4.CdkVirtualScrollViewport = (<any>(null as any));
var _decl0_16:i5.CdkConnectedOverlay = (<any>(null as any));
var _decl0_17:i5.CdkOverlayOrigin = (<any>(null as any));
var _decl0_18:i6.CdkPortal = (<any>(null as any));
var _decl0_19:i6.CdkPortalOutlet = (<any>(null as any));
var _decl0_20:i7.ElPortalDirective = (<any>(null as any));
var _decl0_21:i7.ElPortalOutletDirective = (<any>(null as any));
var _decl0_22:i8.ElOverlayContainerComponent = (<any>(null as any));
var _decl0_23:i9.ElCardComponent = (<any>(null as any));
var _decl0_24:i9.ElCardBodyComponent = (<any>(null as any));
var _decl0_25:i9.ElCardFooterComponent = (<any>(null as any));
var _decl0_26:i9.ElCardHeaderComponent = (<any>(null as any));
var _decl0_27:i10.ElRevealCardComponent = (<any>(null as any));
var _decl0_28:i11.ElFlipCardComponent = (<any>(null as any));
var _decl0_29:i12.ElCardFrontComponent = (<any>(null as any));
var _decl0_30:i12.ElCardBackComponent = (<any>(null as any));
var _decl0_31:i13.ElIconComponent = (<any>(null as any));
var _decl0_32:i14.ElButtonComponent = (<any>(null as any));
var _decl0_33:i15.ElWindowsContainerComponent = (<any>(null as any));
var _decl0_34:i16.ElWindowComponent = (<any>(null as any));
var _decl0_35:i2.AsyncPipe = (<any>(null as any));
var _decl0_36:i2.UpperCasePipe = (<any>(null as any));
var _decl0_37:i2.LowerCasePipe = (<any>(null as any));
var _decl0_38:i2.JsonPipe = (<any>(null as any));
var _decl0_39:i2.SlicePipe = (<any>(null as any));
var _decl0_40:i2.DecimalPipe = (<any>(null as any));
var _decl0_41:i2.PercentPipe = (<any>(null as any));
var _decl0_42:i2.TitleCasePipe = (<any>(null as any));
var _decl0_43:i2.CurrencyPipe = (<any>(null as any));
var _decl0_44:i2.DatePipe = (<any>(null as any));
var _decl0_45:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_46:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_47:i2.KeyValuePipe = (<any>(null as any));
var _decl0_48:i2.CommonModule = (<any>(null as any));
var _decl0_49:i17.ElOverlayModule = (<any>(null as any));
var _decl0_50:i18.ElCardModule = (<any>(null as any));
var _decl0_51:i19.ElIconModule = (<any>(null as any));
var _decl0_52:i20.ElButtonModule = (<any>(null as any));
var _decl0_53:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_54:i0.ElementRef<any> = (<any>(null as any));
function _View_ElWindowsContainerComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_ElWindowsContainerComponent_1_0():void {
  var _any:any = (null as any);
}
function _View_ElWindowComponent_Host_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_34.isFullScreen;
  currVal_0;
  const currVal_1:any = _decl0_34.maximized;
  currVal_1;
  const currVal_2:any = _decl0_34.minimized;
  currVal_2;
}
function _View_ElWindowComponent_2_1():void {
  if (_decl0_34.isFullScreen) {
    var _any:any = (null as any);
    const currVal_0:any = '';
    currVal_0;
    const currVal_1:any = _decl0_32.filled;
    currVal_1;
    const currVal_2:any = _decl0_32.outline;
    currVal_2;
    const currVal_3:any = _decl0_32.ghost;
    currVal_3;
    const currVal_4:any = _decl0_32.hero;
    currVal_4;
    const currVal_5:any = _decl0_32.fullWidth;
    currVal_5;
    const currVal_6:any = _decl0_32.disabled;
    currVal_6;
    const currVal_7:any = _decl0_32.disabled;
    currVal_7;
    const currVal_8:any = _decl0_32.tabbable;
    currVal_8;
    const currVal_9:any = _decl0_32.tiny;
    currVal_9;
    const currVal_10:any = _decl0_32.small;
    currVal_10;
    const currVal_11:any = _decl0_32.medium;
    currVal_11;
    const currVal_12:any = _decl0_32.large;
    currVal_12;
    const currVal_13:any = _decl0_32.giant;
    currVal_13;
    const currVal_14:any = _decl0_32.primary;
    currVal_14;
    const currVal_15:any = _decl0_32.info;
    currVal_15;
    const currVal_16:any = _decl0_32.success;
    currVal_16;
    const currVal_17:any = _decl0_32.warning;
    currVal_17;
    const currVal_18:any = _decl0_32.danger;
    currVal_18;
    const currVal_19:any = _decl0_32.rectangle;
    currVal_19;
    const currVal_20:any = _decl0_32.round;
    currVal_20;
    const currVal_21:any = _decl0_32.semiRound;
    currVal_21;
    const currVal_22:any = _decl0_32.iconLeft;
    currVal_22;
    const currVal_23:any = _decl0_32.iconRight;
    currVal_23;
    const currVal_24:any = _decl0_32.transitions;
    currVal_24;
    const currVal_25:any = 'collapse-outline';
    currVal_25;
    const currVal_26:any = 'endlessjs-essentials';
    currVal_26;
    const currVal_27:any = _decl0_31.html;
    currVal_27;
    const currVal_28:any = _decl0_31.primary;
    currVal_28;
    const currVal_29:any = _decl0_31.info;
    currVal_29;
    const currVal_30:any = _decl0_31.success;
    currVal_30;
    const currVal_31:any = _decl0_31.warning;
    currVal_31;
    const currVal_32:any = _decl0_31.danger;
    currVal_32;
    const pd_33:any = ((<any>_decl0_32.onClick(_any)) !== false);
    const pd_34:any = ((<any>_decl0_34.maximize()) !== false);
  }
}
function _View_ElWindowComponent_2_2():void {
  if ((_decl0_34.minimized || _decl0_34.maximized)) {
    var _any:any = (null as any);
    const currVal_0:any = '';
    currVal_0;
    const currVal_1:any = _decl0_32.filled;
    currVal_1;
    const currVal_2:any = _decl0_32.outline;
    currVal_2;
    const currVal_3:any = _decl0_32.ghost;
    currVal_3;
    const currVal_4:any = _decl0_32.hero;
    currVal_4;
    const currVal_5:any = _decl0_32.fullWidth;
    currVal_5;
    const currVal_6:any = _decl0_32.disabled;
    currVal_6;
    const currVal_7:any = _decl0_32.disabled;
    currVal_7;
    const currVal_8:any = _decl0_32.tabbable;
    currVal_8;
    const currVal_9:any = _decl0_32.tiny;
    currVal_9;
    const currVal_10:any = _decl0_32.small;
    currVal_10;
    const currVal_11:any = _decl0_32.medium;
    currVal_11;
    const currVal_12:any = _decl0_32.large;
    currVal_12;
    const currVal_13:any = _decl0_32.giant;
    currVal_13;
    const currVal_14:any = _decl0_32.primary;
    currVal_14;
    const currVal_15:any = _decl0_32.info;
    currVal_15;
    const currVal_16:any = _decl0_32.success;
    currVal_16;
    const currVal_17:any = _decl0_32.warning;
    currVal_17;
    const currVal_18:any = _decl0_32.danger;
    currVal_18;
    const currVal_19:any = _decl0_32.rectangle;
    currVal_19;
    const currVal_20:any = _decl0_32.round;
    currVal_20;
    const currVal_21:any = _decl0_32.semiRound;
    currVal_21;
    const currVal_22:any = _decl0_32.iconLeft;
    currVal_22;
    const currVal_23:any = _decl0_32.iconRight;
    currVal_23;
    const currVal_24:any = _decl0_32.transitions;
    currVal_24;
    const currVal_25:any = 'expand-outline';
    currVal_25;
    const currVal_26:any = 'endlessjs-essentials';
    currVal_26;
    const currVal_27:any = _decl0_31.html;
    currVal_27;
    const currVal_28:any = _decl0_31.primary;
    currVal_28;
    const currVal_29:any = _decl0_31.info;
    currVal_29;
    const currVal_30:any = _decl0_31.success;
    currVal_30;
    const currVal_31:any = _decl0_31.warning;
    currVal_31;
    const currVal_32:any = _decl0_31.danger;
    currVal_32;
    const pd_33:any = ((<any>_decl0_32.onClick(_any)) !== false);
    const pd_34:any = ((<any>_decl0_34.maximizeOrFullScreen()) !== false);
  }
}
function _View_ElWindowComponent_2_3():void {
  if ((_decl0_34.maximized || _decl0_34.isFullScreen)) { var _any:any = (null as any); }
}
function _View_ElWindowComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_23.tiny;
  currVal_0;
  const currVal_1:any = _decl0_23.small;
  currVal_1;
  const currVal_2:any = _decl0_23.medium;
  currVal_2;
  const currVal_3:any = _decl0_23.large;
  currVal_3;
  const currVal_4:any = _decl0_23.giant;
  currVal_4;
  const currVal_5:any = _decl0_23.primary;
  currVal_5;
  const currVal_6:any = _decl0_23.info;
  currVal_6;
  const currVal_7:any = _decl0_23.success;
  currVal_7;
  const currVal_8:any = _decl0_23.warning;
  currVal_8;
  const currVal_9:any = _decl0_23.danger;
  currVal_9;
  const currVal_10:any = _decl0_23.hasAccent;
  currVal_10;
  const currVal_11:any = _decl0_23.primaryAccent;
  currVal_11;
  const currVal_12:any = _decl0_23.infoAccent;
  currVal_12;
  const currVal_13:any = _decl0_23.successAccent;
  currVal_13;
  const currVal_14:any = _decl0_23.warningAccent;
  currVal_14;
  const currVal_15:any = _decl0_23.dangerAccent;
  currVal_15;
  const currVal_16:any = _decl0_34.config.title;
  currVal_16;
  const currVal_17:any = '';
  currVal_17;
  const currVal_18:any = _decl0_32.filled;
  currVal_18;
  const currVal_19:any = _decl0_32.outline;
  currVal_19;
  const currVal_20:any = _decl0_32.ghost;
  currVal_20;
  const currVal_21:any = _decl0_32.hero;
  currVal_21;
  const currVal_22:any = _decl0_32.fullWidth;
  currVal_22;
  const currVal_23:any = _decl0_32.disabled;
  currVal_23;
  const currVal_24:any = _decl0_32.disabled;
  currVal_24;
  const currVal_25:any = _decl0_32.tabbable;
  currVal_25;
  const currVal_26:any = _decl0_32.tiny;
  currVal_26;
  const currVal_27:any = _decl0_32.small;
  currVal_27;
  const currVal_28:any = _decl0_32.medium;
  currVal_28;
  const currVal_29:any = _decl0_32.large;
  currVal_29;
  const currVal_30:any = _decl0_32.giant;
  currVal_30;
  const currVal_31:any = _decl0_32.primary;
  currVal_31;
  const currVal_32:any = _decl0_32.info;
  currVal_32;
  const currVal_33:any = _decl0_32.success;
  currVal_33;
  const currVal_34:any = _decl0_32.warning;
  currVal_34;
  const currVal_35:any = _decl0_32.danger;
  currVal_35;
  const currVal_36:any = _decl0_32.rectangle;
  currVal_36;
  const currVal_37:any = _decl0_32.round;
  currVal_37;
  const currVal_38:any = _decl0_32.semiRound;
  currVal_38;
  const currVal_39:any = _decl0_32.iconLeft;
  currVal_39;
  const currVal_40:any = _decl0_32.iconRight;
  currVal_40;
  const currVal_41:any = _decl0_32.transitions;
  currVal_41;
  const currVal_42:any = 'minus-outline';
  currVal_42;
  const currVal_43:any = 'endlessjs-essentials';
  currVal_43;
  const currVal_44:any = _decl0_31.html;
  currVal_44;
  const currVal_45:any = _decl0_31.primary;
  currVal_45;
  const currVal_46:any = _decl0_31.info;
  currVal_46;
  const currVal_47:any = _decl0_31.success;
  currVal_47;
  const currVal_48:any = _decl0_31.warning;
  currVal_48;
  const currVal_49:any = _decl0_31.danger;
  currVal_49;
  const currVal_50:any = _decl0_34.isFullScreen;
  currVal_50;
  const currVal_51:any = (_decl0_34.minimized || _decl0_34.maximized);
  currVal_51;
  const currVal_52:any = '';
  currVal_52;
  const currVal_53:any = _decl0_32.filled;
  currVal_53;
  const currVal_54:any = _decl0_32.outline;
  currVal_54;
  const currVal_55:any = _decl0_32.ghost;
  currVal_55;
  const currVal_56:any = _decl0_32.hero;
  currVal_56;
  const currVal_57:any = _decl0_32.fullWidth;
  currVal_57;
  const currVal_58:any = _decl0_32.disabled;
  currVal_58;
  const currVal_59:any = _decl0_32.disabled;
  currVal_59;
  const currVal_60:any = _decl0_32.tabbable;
  currVal_60;
  const currVal_61:any = _decl0_32.tiny;
  currVal_61;
  const currVal_62:any = _decl0_32.small;
  currVal_62;
  const currVal_63:any = _decl0_32.medium;
  currVal_63;
  const currVal_64:any = _decl0_32.large;
  currVal_64;
  const currVal_65:any = _decl0_32.giant;
  currVal_65;
  const currVal_66:any = _decl0_32.primary;
  currVal_66;
  const currVal_67:any = _decl0_32.info;
  currVal_67;
  const currVal_68:any = _decl0_32.success;
  currVal_68;
  const currVal_69:any = _decl0_32.warning;
  currVal_69;
  const currVal_70:any = _decl0_32.danger;
  currVal_70;
  const currVal_71:any = _decl0_32.rectangle;
  currVal_71;
  const currVal_72:any = _decl0_32.round;
  currVal_72;
  const currVal_73:any = _decl0_32.semiRound;
  currVal_73;
  const currVal_74:any = _decl0_32.iconLeft;
  currVal_74;
  const currVal_75:any = _decl0_32.iconRight;
  currVal_75;
  const currVal_76:any = _decl0_32.transitions;
  currVal_76;
  const currVal_77:any = 'close-outline';
  currVal_77;
  const currVal_78:any = 'endlessjs-essentials';
  currVal_78;
  const currVal_79:any = _decl0_31.html;
  currVal_79;
  const currVal_80:any = _decl0_31.primary;
  currVal_80;
  const currVal_81:any = _decl0_31.info;
  currVal_81;
  const currVal_82:any = _decl0_31.success;
  currVal_82;
  const currVal_83:any = _decl0_31.warning;
  currVal_83;
  const currVal_84:any = _decl0_31.danger;
  currVal_84;
  const currVal_85:any = (_decl0_34.maximized || _decl0_34.isFullScreen);
  currVal_85;
  const pd_86:any = ((<any>_decl0_32.onClick(_any)) !== false);
  const pd_87:any = ((<any>_decl0_34.minimize()) !== false);
  const pd_88:any = ((<any>_decl0_32.onClick(_any)) !== false);
  const pd_89:any = ((<any>_decl0_34.close()) !== false);
}
